var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "wrapper", staticClass: "wrapper" }, [
    _c("div", {
      ref: "wrapperBarShim",
      class: {
        "wrapper-bar__shim": _vm.isSticky,
      },
    }),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "wrapperBar",
        staticClass: "wrapper-bar",
        class: {
          "wrapper-bar--sticky": _vm.isSticky,
          "wrapper-bar--small": _vm.isDashButtonSmall,
        },
      },
      [
        _c(
          "div",
          {
            staticClass: "dash-button-bar",
            class:
              ((_obj = {}),
              (_obj["dash-button-bar__stories"] = _vm.isStories),
              (_obj["dash-button-bar--small"] = _vm.isDashButtonSmall),
              (_obj["dash-button-bar--less-equal-three"] = _vm.isLessThree),
              (_obj["dash-button-bar--more-than-three"] = !_vm.isLessThree),
              _obj),
          },
          [_vm._t("default")],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }